import { render, staticRenderFns } from "./UploadADocument.vue?vue&type=template&id=4e8c2d4e&scoped=true"
import script from "./UploadADocument.vue?vue&type=script&lang=js"
export * from "./UploadADocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8c2d4e",
  null
  
)

export default component.exports